import { GenericBaseParameter } from "../base-parameter";
import { PagingListResponse, BaseListing } from "../listing-base-model";
import { IDemandParameterModel } from "./demand-parameter.model";
import { IDemandListing } from "./demand-listing.model";

export class MatchingDemandRequest extends GenericBaseParameter<IDemandParameterModel> {
  PropertyId: number;
    IsMapping: boolean = true;
    IsMatchingDemandSendEmail: boolean = true

  constructor(pageIndex?: number , pageSize?: number, orderBy?: string , fields?: string, condition?: IDemandParameterModel) {
    super(pageIndex, pageSize, orderBy, fields, condition);
  }
}

export class MatchingDemandResponse extends PagingListResponse<IDemandListing> {
  Condition: IDemandParameterModel;
  PropertyReference: string;

  constructor(response?: BaseListing) {
    super(response);

    this.Condition = response.condition;
    delete response.condition;
  }
}